import {QuestionType} from "@reside/forms";

export const isFileReference = (questionType: QuestionType): boolean =>
  [QuestionType.SIGNATURE, QuestionType.IMAGE].indexOf(questionType) > -1;
